/* EU campaign deadlines are absolute instants, including the October DST change. */
(() => {
  class CampaignWindow extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh || (() => this.update());
      this.onPageShow = this.onPageShow || (event => {
        if (event.persisted) this.dismissed = false;
        this.update();
      });
      this.onClose = this.onClose || (event => {
        const button = event.target.closest('[data-rav-campaign-close]');
        if (!button || !this.contains(button)) return;
        this.dismissed = true;
        this.update();
        if (document.activeElement === button) document.querySelector('.rav-header__logo')?.focus({preventScroll: true});
      });
      this.querySelectorAll('[data-rav-campaign-close]').forEach(button => { button.hidden = false; });
      this.addEventListener('click', this.onClose);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.onPageShow);
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.removeEventListener('click', this.onClose);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.onPageShow);
    }
    update() {
      clearTimeout(this.timer);
      if (this.dismissed) {
        this.hidden = true;
        return;
      }
      const now = Date.now();
      const from = this.dataset.from ? Date.parse(this.dataset.from) : -Infinity;
      const until = this.dataset.until ? Date.parse(this.dataset.until) : Infinity;
      this.hidden = !(now >= from && now < until);
      const next = Math.min(...[from, until].filter(t => t > now));
      if (Number.isFinite(next)) this.timer = setTimeout(this.refresh, Math.min(60000, Math.max(1, next - now)));
    }
  }
  if (!customElements.get('rav-campaign-window')) customElements.define('rav-campaign-window', CampaignWindow);

  class CampaignRedirect extends CampaignWindow {
    update() {
      clearTimeout(this.timer);
      const remaining = Date.parse(this.dataset.at) - Date.now();
      if (!Number.isFinite(remaining)) return;
      if (remaining <= 0) {
        // Only the expired birthday landing redirects; product pages stay in place.
        const url = new URL(this.dataset.url, location.origin);
        if (url.origin === location.origin && url.pathname !== location.pathname) location.replace(url.href);
      } else this.timer = setTimeout(this.refresh, Math.min(60000, remaining));
    }
  }
  if (!customElements.get('rav-campaign-redirect')) customElements.define('rav-campaign-redirect', CampaignRedirect);

  class HalloweenSale extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-rav-filter], [data-rav-filter-link]');
        if (!button || !this.contains(button)) return;
        const family = button.dataset.ravFilter || button.dataset.ravFilterLink;
        this.querySelectorAll('[data-rav-filter]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.ravFilter === family)));
        this.querySelectorAll('[data-rav-family]').forEach(el => { el.hidden = family !== 'all' && el.dataset.ravFamily !== family; });
      });
    }
  }
  if (!customElements.get('rav-halloween-sale')) customElements.define('rav-halloween-sale', HalloweenSale);

  let menuTimer;
  function expireMenu() {
    clearTimeout(menuTimer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-rav-until]').forEach(el => {
      const until = Date.parse(el.dataset.ravUntil);
      if (!Number.isFinite(until) || now >= until) el.hidden = true;
      else next = Math.min(next, until);
    });
    if (Number.isFinite(next)) menuTimer = setTimeout(expireMenu, Math.min(60000, Math.max(1, next - now)));
  }
  expireMenu();
  document.addEventListener('visibilitychange', expireMenu);
  window.addEventListener('pageshow', expireMenu);
  document.addEventListener('shopify:section:load', expireMenu);
})();
